import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TicketingComponent } from './ticketing.component';
import { DetailTicketComponent } from './components/detail-ticket/detail-ticket.component';

const routes: Routes = [
  { path: '', component: TicketingComponent },
  { path: 'detail/:id', component: DetailTicketComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TicketingRoutingModule { }
